import {
  type PropsWithChildren,
  type ReactElement,
  type ReactNode,
} from 'react';

import type { SpinButtonGroupSeparatorProps } from './types.js';
import { useBehavioralTrackingProps } from '../../../core/hooks/useBehavioralTrackingProps.js';
import { isSlot } from '../../../core/utils/is-slot.js';

/**
 * Allows to check if a ReactNode is a SpinButtonGroupSeparator element.
 * @internal
 */
export function isSpinButtonGroupSeparator(
  node: ReactNode,
): node is ReactElement<SpinButtonGroupSeparatorProps> {
  return isSlot(node, SpinButtonGroupSeparator);
}

/**
 * Used to define a trigger between spinbuttons. e.g. the colon within a time value 12:34.
 */
export const SpinButtonGroupSeparator = ({
  children,
  trigger,
  className: consumerClassName,
  style: consumerStyle,
  'data-testid': dataTestId,
  ...remainingProps
}: PropsWithChildren<SpinButtonGroupSeparatorProps>) => {
  const [behavioralTrackingProps] = useBehavioralTrackingProps(remainingProps);
  return (
    <span
      className={consumerClassName}
      style={consumerStyle}
      data-testid={dataTestId}
      {...behavioralTrackingProps}
    >
      {children ?? trigger}
    </span>
  );
};
